import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Diensten from "@/pages/Diensten";
import Werkwijze from "@/pages/Werkwijze";
import OverOns from "@/pages/OverOns";
import Offerte from "@/pages/Offerte";
import Contact from "@/pages/Contact";
import Bedankt from "@/pages/Bedankt";
import Legal from "@/pages/Legal";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
        <Routes>
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/diensten" element={<Layout><Diensten /></Layout>} />
          <Route path="/werkwijze" element={<Layout><Werkwijze /></Layout>} />
          <Route path="/over-ons" element={<Layout><OverOns /></Layout>} />
          <Route path="/offerte" element={<Layout><Offerte /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="/bedankt" element={<Layout><Bedankt /></Layout>} />
          <Route path="/privacy" element={<Layout><Legal type="privacy" /></Layout>} />
          <Route path="/algemene-voorwaarden" element={<Layout><Legal type="voorwaarden" /></Layout>} />
          {/* Legacy redirects */}
          <Route path="/projecten" element={<Navigate to="/diensten" replace />} />
          <Route path="/project-aanvragen" element={<Navigate to="/offerte" replace />} />
          <Route path="/leads" element={<Navigate to="/offerte" replace />} />
          <Route path="*" element={<Layout><NotFound /></Layout>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
